import React from 'react';
import { Form, Input, Modal } from '@pankod/refine-antd';

interface LeadProps {
  createModalProps: any;
  createFormProps: any;
  id: string;
  status: string;
}

const LeadModal = ({
  createModalProps,
  createFormProps,
  id,
  status,
}: LeadProps) => {
  return (
    <Modal {...createModalProps}>
      <Form
        {...createFormProps}
        layout='vertical'
        onFinish={(values) =>
          createFormProps.onFinish?.({
            note: values.note,
            source_id: id,
            type: status,
          } as any)
        }
      >
        <Form.Item
          label='Note'
          name='note'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default LeadModal;
